import { render, staticRenderFns } from "./OrganizationSettingsView.vue?vue&type=template&id=3d50118d"
import script from "./OrganizationSettingsView.vue?vue&type=script&lang=js"
export * from "./OrganizationSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports